import { ActionType, createAction, createAsyncAction, createReducer } from 'typesafe-actions';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getAuthUrl } from 'features/page-model';
import { REVIEWS_FORM_HASH } from 'common/constants';
import { ClientVerificationResponse, ClientVerificationState } from '../types';
import { requestClientVerification } from './api';

export const VERIFY_CLIENT = createAction('clientVerification/VERIFY')();
const FETCH_CLIENT_VERIFICATION = createAsyncAction(
  'clientVerification/FETCH/request',
  'clientVerification/FETCH/success',
  'clientVerification/FETCH/failure',
)<void, ClientVerificationResponse, Error>();

const initialState: ClientVerificationState = {
  customerNumber: null,
  status: 'idle',
  error: null,
};

type ClientVerificationActions =
  | ActionType<typeof FETCH_CLIENT_VERIFICATION.request>
  | ActionType<typeof FETCH_CLIENT_VERIFICATION.success>
  | ActionType<typeof FETCH_CLIENT_VERIFICATION.failure>;

export const clientVerificationReducer = createReducer<ClientVerificationState, ClientVerificationActions>(
  initialState,
)
  .handleAction(FETCH_CLIENT_VERIFICATION.request, (state) => ({
    ...state,
    status: 'pending',
    error: null,
  }))
  .handleAction(FETCH_CLIENT_VERIFICATION.success, (state, { payload }) => ({
    ...state,
    customerNumber: payload.customerNumber,
    status: 'succeeded',
    error: null,
  }))
  .handleAction(FETCH_CLIENT_VERIFICATION.failure, (state, { payload }) => ({
    ...state,
    customerNumber: null,
    status: 'failed',
    error: payload.message,
  }));

function* verifyClient() {
  yield put(FETCH_CLIENT_VERIFICATION.request());

  let customerNumber: string | null = null;
  try {
    const result = yield* requestClientVerification();
    yield put(FETCH_CLIENT_VERIFICATION.success(result));
    customerNumber = result.customerNumber;
  } catch (err) {
    yield put(FETCH_CLIENT_VERIFICATION.failure(err as Error));
  }

  const authUrl = (yield select(getAuthUrl)) as ReturnType<typeof getAuthUrl>;
  const targetUrl = customerNumber ? REVIEWS_FORM_HASH : authUrl;

  if (targetUrl) {
    yield call([window.location, 'assign'], targetUrl);
  }
}

export function* clientVerificationSaga() {
  yield takeLatest(VERIFY_CLIENT, verifyClient);
}
